import React from "react";
import PropTypes from "prop-types";

import { Header as BaseHeader } from "shared/react_components/Header";
import HeaderTitle from "shared/react_components/Header/HeaderTitle";
import SecondaryTitle from "shared/react_components/Header/SecondaryTitle";

import Logo from "../Logo";
import IntegrationName from "./IntegrationName";

import { types, metadata } from "integrations/integrationsMetadata";
import { icon, removeMargin } from "./Header.module.scss";

const Header = ({ id, type }) => {
  return (
    <BaseHeader className={removeMargin}>
      <div>
        <div className={"d-inline-block"}>
          <Logo type={type} className={icon}/>
        </div>
        <div className={"d-inline-block"}>
          <SecondaryTitle className={"ml-1 mb-0"}>{`Connect Apps > ${metadata[type]['name']}`.toUpperCase()}</SecondaryTitle>
          <HeaderTitle>
            <IntegrationName id={id} type={type}/>
          </HeaderTitle>
        </div>
      </div>
    </BaseHeader>
  );
};

Header.propTypes = {
  id: PropTypes.number,
  type: PropTypes.oneOf(types).isRequired
};

export default Header;
